export default "__VITE_ASSET__033df45d__"